import React, { useEffect } from "react";
import { InputNumber, Select, Form, Input } from "antd";
import { UserRole, RateBy } from "../../lib/constants";

export default function EmployeeForm({ onFormInstanceReady }) {
    const [form] = Form.useForm();

    useEffect(() => {
        onFormInstanceReady(form);
    }, [form, onFormInstanceReady]);


    return (
        <Form form={form} layout="vertical"  >

            <div className="grid grid-cols-2 gap-x-4 ">
                <Form.Item
                    name={"firstName"}
                    label="First Name"
                    rules={[
                        {
                            required: true
                        }
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name={"lastName"}
                    label="Last Name"
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name={"role"}
                    label="Role"
                    rules={[
                        { required: true },
                    ]}
                >
                    <Select
                        options={Object.keys(UserRole).map((status) => {
                            return {
                                value: UserRole[status],
                                label: status
                            }
                        })}
                    />
                </Form.Item>
                <Form.Item
                    name={"email"}
                    label="Email Address"
                    rules={[
                        {
                            required: true,
                            type: "email",
                        }
                    ]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name={"phone"}
                    label="Phone"
                    className="col-span-2"
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name={"rate"}
                    label="Rate"
                >
                    <InputNumber addonBefore="AU$" defaultValue={0.00} min={0} step={"1.00"} className="w-full" />
                </Form.Item>
                <Form.Item
                    name={"rateBy"}
                    label="Rate by"
                >
                    <Select options={Object.keys(RateBy).map((rate) => {
                        return {
                            value: RateBy[rate],
                            label: rate
                        }
                    })} />
                </Form.Item>
                <Form.Item
                    name={"password"}
                    label="Password"
                    rules={[
                        { required: true },
                    ]}
                >
                    <Input.Password />
                </Form.Item>
                <Form.Item
                    name={"confirmPassword"}
                    label="Confirm Password"
                    rules={[
                        { required: true },
                    ]}
                >
                    <Input.Password />
                </Form.Item>
                {/* <p className="col-span-2">Attachments:</p>
                <Form.Item
                    name={"documentName"}
                    label="Document Name"
                >
                    <Input />
                </Form.Item>
                <div className="flex space-x-4">
                    <Form.Item
                        name={"documentExpiryDate"}
                        label="Expiry Date"
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name={"atachement"}
                        label="Attachment"
                    >
                        <Input />
                    </Form.Item>
                </div> */}
            </div>

            {/* <Button type="link"><PlusOutlined /> Add Document</Button> */}
        </Form>
    )
}
